/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Meeting history param type
 * @export
 * @enum {string}
 */
export enum MeetingHistoryType {
    Past = 'PAST',
    Future = 'FUTURE'
}

export function MeetingHistoryTypeFromJSON(json: any): MeetingHistoryType {
    return MeetingHistoryTypeFromJSONTyped(json, false);
}

export function MeetingHistoryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeetingHistoryType {
    return json as MeetingHistoryType;
}

export function MeetingHistoryTypeToJSON(value?: MeetingHistoryType | null): any {
    return value as any;
}

